import React, { useState, useEffect } from "react";
import "./PlacedStudentProfile.css";
import { LeftOutlined, RightOutlined, RocketOutlined, LineChartOutlined, MobileOutlined, ThunderboltOutlined, LayoutOutlined, SettingOutlined, DatabaseOutlined, TeamOutlined, GlobalOutlined, CloudOutlined, ToolOutlined, CodeOutlined,
  SolutionOutlined, NotificationOutlined, AppstoreOutlined, KeyOutlined, SearchOutlined, SafetyCertificateOutlined, PieChartOutlined, BulbOutlined, RiseOutlined, ShareAltOutlined,
  DeploymentUnitOutlined, CloudServerOutlined,
} from "@ant-design/icons";

import { allStudents } from '../../data/siteData';

/*======================================
        COURSE CATEGORIES
=======================================*/
const categories = [
  {
    key: "fullstack",
    badgeTitle: "Full Stack Development",
    cornerIcon: <RocketOutlined />,
    title: "Full Stack Development",
    meta1: "Beginner to Advanced",
    meta2: "6 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "6 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "BUILD",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Master complete web development by learning frontend, backend, databases, APIs and deployment. Build real-world projects and become job-ready as a Full Stack Developer.",
      sections: [
        { title: "Frontend Development", icon: <LayoutOutlined />, items: ["HTML5", "CSS3", "JavaScript", "React.js", "Responsive Web Design", "Bootstrap", "UI Components"] },
        { title: "Backend Development", icon: <SettingOutlined />, items: ["Python", "Django", "Django REST Framework", "REST API", "JWT Authentication", "CRUD Operations", "API Integration"] },
        { title: "Database", icon: <DatabaseOutlined />, items: ["MySQL", "PostgreSQL", "MongoDB", "Database Design", "SQL Queries"] },
        { title: "Tools & Technologies", icon: <ToolOutlined />, items: ["Git", "GitHub", "Postman", "VS Code", "NPM", "API Testing"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Portfolio Website", "E-Commerce Website", "Authentication System", "REST API Project", "Full Stack Web Application"] },
      ],
    },
  },

  {
    key: "data",
    badgeTitle: "Data Analytics",
    cornerIcon: <LineChartOutlined />,
    title: "Data Analytics",
    meta1: "Beginner",
    meta2: "4 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "4 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "ANALYZE",
    bottomLeft: "BEGINNER",
    bottomRight: "APPLY",
   color: "#ff7a18",
    viewDetails: {
      description:
        "Learn how to collect, clean, analyze and visualize data to discover useful insights and support smarter business decisions using Python, Excel & Power BI.",
      sections: [
        { title: "Data Analytics Fundamentals", icon: <PieChartOutlined />, items: ["Data Analysis Basics", "Data Cleaning", "Data Preparation", "Statistical Analysis", "Data Interpretation"] },
        { title: "Python for Data Analysis", icon: <CodeOutlined />, items: ["Python", "NumPy", "Pandas", "DataFrames", "Data Processing"] },
        { title: "Data Visualization", icon: <LineChartOutlined />, items: ["Matplotlib", "Seaborn", "Charts & Graphs", "Dashboard Creation", "Power BI"] },
        { title: "Database & Excel", icon: <DatabaseOutlined />, items: ["SQL", "MySQL", "Microsoft Excel", "Data Filtering", "Data Reporting"] },
        { title: "Tools", icon: <ToolOutlined />, items: ["Jupyter Notebook", "Google Colab", "VS Code", "Git", "GitHub"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Sales Data Analysis", "Student Performance Analysis", "Business Dashboard", "Data Visualization Project"] },
      ],
    },
  },

  {
    key: "app",
    badgeTitle: "Mobile App Development",
    cornerIcon: <ThunderboltOutlined />,
    title: "Mobile App Development",
    meta1: "Beginner to Advanced",
    meta2: "4 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "4 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "CREATE",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Learn to design, develop and deploy modern Android & iOS mobile applications using Flutter, React Native and real-world project training.",
      sections: [
        { title: "Programming Fundamentals", icon: <BulbOutlined />, items: ["Programming Basics", "Variables & Functions", "Object Oriented Programming", "Logic Building"] },
        { title: "Mobile Development", icon: <MobileOutlined />, items: ["Flutter", "Dart", "React Native", "Mobile UI Design", "Responsive App Design"] },
        { title: "Backend & API", icon: <SettingOutlined />, items: ["REST API", "API Integration", "Firebase", "Authentication", "Cloud Database"] },
        { title: "Database", icon: <DatabaseOutlined />, items: ["Firebase Firestore", "SQLite", "MySQL", "Local Storage"] },
        { title: "Tools", icon: <ToolOutlined />, items: ["Android Studio", "VS Code", "Git", "GitHub", "Postman"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Login & Registration App", "QR Attendance App", "E-Commerce App", "Student Management App"] },
      ],
    },
  },

  {
    key: "frontend",
    badgeTitle: "Frontend Development",
    cornerIcon: <AppstoreOutlined />,
    title: "Frontend Development",
    meta1: "Beginner to Advanced",
    meta2: "3 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "3 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "DESIGN",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Master modern frontend development to build fast, responsive, and beautiful websites using HTML, CSS, JavaScript and React.js with real projects.",
      sections: [
        { title: "Web Fundamentals", icon: <GlobalOutlined />, items: ["HTML5", "CSS3", "Semantic HTML", "CSS Flexbox", "CSS Grid", "Responsive Design"] },
        { title: "JavaScript", icon: <ThunderboltOutlined />, items: ["JavaScript ES6+", "DOM Manipulation", "Event Handling", "Async/Await", "Fetch API"] },
        { title: "React.js", icon: <CodeOutlined />, items: ["React Basics", "Components & Props", "Hooks", "React Router", "State Management"] },
        { title: "UI & Styling", icon: <LayoutOutlined />, items: ["Bootstrap", "Tailwind CSS", "SASS", "Material UI", "Animations"] },
        { title: "Tools", icon: <ToolOutlined />, items: ["VS Code", "Git", "GitHub", "NPM", "Chrome DevTools"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Portfolio Website", "Landing Page", "React Dashboard", "E-Commerce UI", "Blog Website"] },
      ],
    },
  },

  {
    key: "backend",
    badgeTitle: "Backend Development",
    cornerIcon: <DatabaseOutlined />,
    title: "Backend Development",
    meta1: "Beginner to Advanced",
    meta2: "5 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "5 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "BUILD",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Become a skilled backend developer by mastering server-side programming, REST APIs, authentication, databases and deployment for scalable web apps.",
      sections: [
        { title: "Programming Language", icon: <CodeOutlined />, items: ["Python", "OOP Concepts", "Data Structures", "Error Handling", "File Handling"] },
        { title: "Backend Framework", icon: <SettingOutlined />, items: ["Django", "Django REST Framework", "Node.js Basics", "Express.js", "Middleware"] },
        { title: "APIs & Auth", icon: <KeyOutlined />, items: ["REST API", "JWT Authentication", "OAuth", "API Testing", "Postman"] },
        { title: "Database", icon: <DatabaseOutlined />, items: ["MySQL", "PostgreSQL", "MongoDB", "ORM", "Database Design"] },
        { title: "Deployment", icon: <CloudOutlined />, items: ["Git & GitHub", "AWS Basics", "Server Hosting", "Docker Basics", "CI/CD Intro"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Authentication System", "Blog REST API", "E-Commerce Backend", "Payment Integration", "Admin Panel"] },
      ],
    },
  },

  {
    key: "hrmarketing",
    badgeTitle: "HR & Marketing",
    cornerIcon: <NotificationOutlined />,
    title: "HR & Marketing",
    meta1: "Beginner to Advanced",
    meta2: "3 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "3 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "GROW",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Learn the essentials of Human Resource Management and Marketing — from recruitment and employee engagement to brand building and modern marketing strategies.",
      sections: [
        { title: "HR Fundamentals", icon: <TeamOutlined />, items: ["Introduction to HR", "Recruitment Process", "Interview Techniques", "Onboarding", "HR Policies"] },
        { title: "Employee Management", icon: <SolutionOutlined />, items: ["Employee Engagement", "Performance Management", "Payroll Basics", "Training & Development", "Leave Management"] },
        { title: "Marketing Basics", icon: <NotificationOutlined />, items: ["Marketing Fundamentals", "Branding", "Market Research", "Consumer Behavior", "Sales Funnel"] },
        { title: "Digital Marketing Intro", icon: <GlobalOutlined />, items: ["Social Media Marketing", "Email Marketing", "Content Marketing", "SEO Basics", "Google Ads"] },
        { title: "Tools", icon: <ToolOutlined />, items: ["HRMS Tools", "MS Excel", "Canva", "LinkedIn Recruiter", "Meta Business Suite"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Recruitment Drive Plan", "Employee Handbook", "Marketing Campaign", "Social Media Strategy"] },
      ],
    },
  },

  {
    key: "digitalmarketing",
    badgeTitle: "Digital Marketing",
    cornerIcon: <RiseOutlined />,
    title: "Digital Marketing",
    meta1: "Beginner to Advanced",
    meta2: "4 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "4 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "PROMOTE",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Master digital marketing with SEO, social media, Google Ads, content marketing and analytics — become a job-ready digital marketer with practical campaigns.",
      sections: [
        { title: "Digital Marketing Basics", icon: <GlobalOutlined />, items: ["Introduction to Digital Marketing", "Types of Digital Marketing", "Marketing Funnel", "Buyer Persona"] },
        { title: "SEO", icon: <SearchOutlined />, items: ["On-Page SEO", "Off-Page SEO", "Technical SEO", "Keyword Research", "Google Search Console"] },
        { title: "Social Media Marketing", icon: <ShareAltOutlined />, items: ["Instagram Marketing", "Facebook Ads", "LinkedIn Marketing", "YouTube Marketing", "Content Strategy"] },
        { title: "Paid Advertising", icon: <NotificationOutlined />, items: ["Google Ads", "Meta Ads", "Performance Marketing", "Retargeting", "Ad Copywriting"] },
        { title: "Analytics & Tools", icon: <ToolOutlined />, items: ["Google Analytics", "Meta Business Suite", "Canva", "Mailchimp", "Semrush"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["SEO Website Audit", "Social Media Campaign", "Google Ads Campaign", "Email Marketing Project", "Brand Strategy Plan"] },
      ],
    },
  },

  {
    key: "cloud",
    badgeTitle: "Cloud Engineering",
    cornerIcon: <DeploymentUnitOutlined />,
    title: "Cloud Engineering",
    meta1: "Beginner to Advanced",
    meta2: "5 Months",
    topLeft: "ONLINE / OFFLINE",
    topRight: "5 MONTHS",
    leftLabel: "JOIN",
    rightLabel: "DEPLOY",
    bottomLeft: "ALL LEVELS",
    bottomRight: "APPLY",
    color: "#ff7a18",
    viewDetails: {
      description:
        "Become a Cloud Engineer by mastering AWS, Azure, DevOps tools, deployment pipelines and scalable cloud infrastructure with real-world projects.",
      sections: [
        { title: "Cloud Fundamentals", icon: <CloudOutlined />, items: ["What is Cloud Computing", "IaaS / PaaS / SaaS", "Public vs Private Cloud", "Cloud Architecture"] },
        { title: "AWS", icon: <CloudServerOutlined />, items: ["EC2", "S3", "IAM", "RDS", "Lambda", "VPC", "CloudWatch"] },
        { title: "Azure Basics", icon: <LayoutOutlined />, items: ["Azure Basics", "Azure VM", "Azure Storage", "Google Cloud Overview", "Compute Engine"] },
        { title: "DevOps & CI/CD", icon: <SettingOutlined />, items: ["Linux Basics", "Git & GitHub", "Docker", "Kubernetes Intro", "Jenkins", "CI/CD Pipelines"] },
        { title: "Security & Monitoring", icon: <SafetyCertificateOutlined />, items: ["Cloud Security", "IAM Policies", "Monitoring Tools", "Backup & Recovery"] },
        { title: "Projects", icon: <RocketOutlined />, items: ["Static Website on S3", "Deploy Web App on EC2", "CI/CD Pipeline Setup", "Serverless API with Lambda", "Kubernetes Cluster Deployment"] },
      ],
    },
  },
];


export default function PlacedStudents() {
  const [current, setCurrent] = useState(0);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const students = allStudents; 
  const cardsPerView = 4;
  const totalSlides = Math.max(1, Math.ceil(students.length / cardsPerView));

  useEffect(() => {
    setCurrent(0);
  }, []);

  useEffect(() => {
    if (students.length === 0) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % totalSlides);
    }, 3500);
    return () => clearInterval(timer);
  }, [current, students.length, totalSlides]);

  const nextSlide = () => {
    if (students.length === 0) return;
    setCurrent((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    if (students.length === 0) return;
    setCurrent((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const openCourseDetails = (course) => setSelectedCourse(course);
  const closeCourseDetails = () => setSelectedCourse(null);

  return (
    <>
      {/* ==========================================
            COURSE FILTER SECTION
      =========================================== */}
      <section className="course-filter-section">
        <div className="course-filter-title">
          <span className="course-filter-subtitle">🎓 Training & Internship</span>
          <p>
            Learn from experienced mentors, work on real-world projects, and gain practical skills to become industry-ready.
          </p>
        </div>

        <div className="course-filter-cards">
          {categories.map((card) => (
            <div
              key={card.key}
              className={"career-card"}
              style={{ "--card-color": card.color }}

            >
              <div className="career-card-top">
                <div className="career-corner-icon">{card.cornerIcon}</div>
                <span className="career-label career-label-tl">{card.topLeft}</span>
                <span className="career-label career-label-tr">{card.topRight}</span>
                <span className="career-label career-label-bl">{card.bottomLeft}</span>
                <span className="career-label career-label-br">{card.bottomRight}</span>
                <span className="career-label career-label-left">{card.leftLabel}</span>
                <span className="career-label career-label-right">{card.rightLabel}</span>

                <svg className="career-paths" viewBox="0 0 300 160" fill="none">
                  <path d="M30 40 Q 80 20, 120 70" stroke="rgba(0,0,0,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
                  <path d="M270 40 Q 220 20, 180 70" stroke="rgba(0,0,0,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
                  <path d="M40 130 Q 100 110, 130 90" stroke="rgba(0,0,0,0.07)" strokeWidth="1.5" strokeDasharray="4 4" />
                  <path d="M260 130 Q 200 110, 170 90" stroke="rgba(0,0,0,0.07)" strokeWidth="1.5" strokeDasharray="4 4" />
                </svg>

                <div className="career-float-badge">
                  <span className="career-float-icon">{card.badgeIcon}</span>
                  <span className="career-float-title">{card.badgeTitle}</span>
                </div>
              </div>

              <div className="career-card-bottom">
                <h3 className="career-card-title">{card.title}</h3>
                <div className="career-card-meta">
                  <span>{card.meta1}</span>
                  <span className="career-dot"></span>
                  <span>{card.meta2}</span>
                </div>

                <button
                  type="button"
                  className="career-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    openCourseDetails(card);
                  }}
                >
                  View Details
                  <span>→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* ==========================================
            COURSE DETAILS MODAL
      =========================================== */}
      {selectedCourse && (
        <div className="course-modal-overlay" onClick={closeCourseDetails}>
          <div
            className="course-modal"
            style={{ "--modal-color": selectedCourse.color }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="course-modal-header">
              <span className="course-modal-badge">
                <span style={{ marginRight: "5px" }}>{selectedCourse.badgeIcon}</span>
                {selectedCourse.badgeTitle} Track
              </span>
              <h2>{selectedCourse.title}</h2>
              <p>🎓 {selectedCourse.meta1} &nbsp;&nbsp;|&nbsp;&nbsp; ⏱ {selectedCourse.meta2}</p>

              <button
                type="button"
                className="course-modal-close"
                onClick={closeCourseDetails}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            {/* Modal Content */}
            <div className="course-modal-content">
              <div className="course-detail-section">
                <h3>Overview</h3>
                <p>{selectedCourse.viewDetails.description}</p>
              </div>

              {selectedCourse.viewDetails.sections.map((section, index) => (
                <div className="course-detail-section" key={index}>
                  <h3>
                    <span style={{ marginRight: "8px" }}>{section.icon}</span>
                    {section.title}
                  </h3>
                  <div className="course-tech-tags">
                    {section.items.map((item, itemIndex) => (
                      <span key={itemIndex} className="course-tech-tag">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Modal Footer */}
            <div className="course-modal-footer">
              <div className="course-modal-footer-text">
                <strong style={{ color: "#374151", fontSize: "13px" }}>
                  Ready to start your journey?
                </strong>
                <br />
                Build practical skills and become career-ready.
              </div>
              <button type="button" className="course-apply-btn" onClick={closeCourseDetails}>
                Apply Now →
              </button>
            </div>
          </div>
        </div>
      )}


      {/* ==========================================
            PLACED STUDENTS SECTION
      =========================================== */}
      <section className="placed-section">
        <div className="placed-section-title">
          <span className="placed-badge">🚀 Proud Alumni & Placements</span>
          <h2>Our Successful <span>Students</span></h2>
          <p>Meet our talented graduates who turned their dedication into successful IT careers.</p>
        </div>

        {students.length === 0 ? (
          <div className="placed-no-students">
            <p>No students found for this category.</p>
          </div>
        ) : (
          <>
            <div className="placed-slider-wrapper">
              <button className="placed-arrow placed-left" onClick={prevSlide}>
                <LeftOutlined />
              </button>

              <div className="placed-cards">
                {students
                  .slice(current * cardsPerView, current * cardsPerView + cardsPerView)
                  .map((student, index) => (
                    <div className="placed-student-card" key={`${student.name}-${index}`}>
                      <div className="placed-image-box">
                        <img src={student.photo} alt={student.name} />
                      </div>
                      <div className="placed-student-info">
                        <h3>{student.name}</h3>
                        <p>{student.role}</p>
                      </div>
                    </div>
                  ))}
              </div>

              <button className="placed-arrow placed-right" onClick={nextSlide}>
                <RightOutlined />
              </button>
            </div>

            <div className="placed-dots">
              {[...Array(totalSlides)].map((_, index) => (
                <span
                  key={index}
                  className={current === index ? "placed-dot placed-active" : "placed-dot"}
                  onClick={() => setCurrent(index)}
                />
              ))}
            </div>
          </>
        )}
      </section>
    </>
  );
}